import React from "react";
import Select from "react-select";
import styled from "styled-components/macro";
import { NavBarItemDropdownMenuProps } from "../types";
import {
  Control,
  Menu,
  MenuList,
  Option,
  SelectContainer,
  Placeholder,
  DropdownIndicator,
} from "../overrideComponents";

const StyledNavBarDropdownMenu = styled.div`
  height: 53px;
  line-height: 53px;
  padding: 0 16px 0 8px;
  width: fit-content;
  &:hover {
    background-color: #435360;
  }
`;

const NavBarItemDropdownMenu = ({
  options,
  value,
}: NavBarItemDropdownMenuProps) => {
  return (
    <StyledNavBarDropdownMenu>
      <Select
        components={{
          SelectContainer,
          Option,
          Menu,
          MenuList,
          Control,
          IndicatorSeparator: () => null,
          Placeholder,
          DropdownIndicator,
        }}
        controlShouldRenderValue={false}
        options={options}
        placeholder={value}
        isSearchable={false}
      />
    </StyledNavBarDropdownMenu>
  );
};

export default NavBarItemDropdownMenu;
